import {CONFIGURATION_ES} from './LANG/ES_DEF';
import {CONFIGURATION_EN} from './LANG/EN_DEF';
import {CONFIGURATION_PT} from './LANG/PT_DEF';

export const translations = {
  es: CONFIGURATION_ES,
  en: CONFIGURATION_EN,
  pt: CONFIGURATION_PT,
}
